export default {
  alert: {
    alertMessage: 'Não é possível ver Sentimentos, Temas ou Tags nas publicações do TikTok, por isso desabilitamos as páginas correspondentes.',
    linkText: 'Saiba mais na Central de Ajuda',
  },
};
